import { auth, type SchemaResponse } from "@/modules/api"

// Response type for checking policy agreement
export interface PaymentPolicyAgreementResponse {
  id: number
  status: boolean
  type: string
  device: string | null
  userId: number
  createdAt: string
  updatedAt: string
}

// Payload type for saving policy agreement
export interface SavePaymentPolicyPayload {
  deviceName: string
  type?: string
}

/**
 * Check if user has agreed to payment policy
 */
export const getPaymentPolicyAgreement = () => {
  return auth.get<SchemaResponse<PaymentPolicyAgreementResponse>>("user/payment-policy-agreement")
}

/**
 * Save user's payment policy agreement
 */
export const savePaymentPolicyAgreement = (data: SavePaymentPolicyPayload) => {
  return auth.post<SchemaResponse<null>>("user/payment-policy-agreement", data)
}
